<template>
  <div
    class="relative w-full h-full cursor-pointer flex justify-center items-center"
    :class="[videoBackground, { 'rounded-12!' : isRounded }]"
    @click="onRootClick($event)"
  >
    <video
      ref="video"
      :class="{ 'rounded-12!' : isRounded }"
      class="h-full w-full bg-black/85 rounded-8 object-cover"
      muted
      :src="src"
      loop
      controls
      autoplay
    />
  </div>
</template>

<script lang="ts" setup>
import { IMFile } from '@wui/im'
import { computed, onUnmounted, ref } from 'vue'

const props = defineProps<{
  src: string,
  file: IMFile,
  isRounded?: boolean,
  type?: 'IncomingMessage' | 'OutgoingMessage',
}>()

const emits = defineEmits(['on-video-click'])
const video = ref<HTMLMediaElement>()

const videoBackground = computed(() => {
  return props.type === 'IncomingMessage'
    ? 'bg-surf-bg-def'
    : 'bg-comp-messages-bubble-bg-out-pres'
})

const onRootClick = (event: Event) => {
  if (!video.value) {
    return
  }
  event.preventDefault()
  video.value.pause()
  emits('on-video-click', props.file)
}

onUnmounted(() => {
  video.value?.pause()
})
</script>
